export const getKnowledgeBasesUrl = () => '/business/knowledgebases';

export const getKnowledgeBaseUrl = (id: string) => `/business/knowledgebases/${id}`;

export const getCloneKnowledgeBaseUrl = (id: number) => `/business/knowledgebases/${id}/clone`;

export const getDataSetsUrls = (knowledgeBaseId: string) => `/business/knowledgebases/${knowledgeBaseId}/datasets`;

export const getDataSetUrls = (knowledgeBaseId: string, id: string) =>
  `/business/knowledgebases/${knowledgeBaseId}/datasets/${id}`;

export const getRetrieveChunkUrl = (knowledgeBaseId: string) =>
  `business/knowledgebases/${knowledgeBaseId}/retrieval_testing`;

export const getChunksUrls = (knowledgeBaseId: string, datasetId: string) =>
  `/business/knowledgebases/${knowledgeBaseId}/datasets/${datasetId}/chunks`;

export const getChunkUrls = (knowledgeBaseId: string, datasetId: string, chunkId: string) =>
  `/business/knowledgebases/${knowledgeBaseId}/datasets/${datasetId}/chunks/${chunkId}`;

export const getImportQaChunkUrls = (knowledgeBaseId: string, datasetId: string) =>
  `/business/knowledgebases/${knowledgeBaseId}/datasets/${datasetId}/chunks/import`;
